import React from "react";
import PropTypes from "prop-types";
import SFTypography from "../../../typography";
import Avatar from "@mui/material/Avatar";
import { SFStack } from "../../../grid";
import getStyled from "../../../../hooks/getStyled";

const { theme, styled } = getStyled();

const AvatarStyled = styled(Avatar)(({ bgColor, theme }) => ({
  ...theme.typography.formCaption,
  color: theme.palette.white.main,
  width: "30px",
  height: "30px",
  display: "inline-flex",
  marginRight: theme.spacing(1.5),
  fontWeight: 300,
  backgroundColor: bgColor,
}));

let avatarColors = [
  theme.palette.blue400.main,
  theme.palette.purple200.main,
  theme.palette.red500.main,
  theme.palette.teal500.main,
  theme.palette.orange500.main,
  theme.palette.maroon300.main,
  theme.palette.green300.main,
];

const SFCellTextRenderer = (props) => {
  // Read custom props from colDef or context (v33 migration)
  const customElement = props.colDef?.textComponent ?? props.colDef?.context?.textComponent;
  const alignItems = props.colDef?.alignItems ?? props.colDef?.context?.alignItems ?? "center";
  const avatar = props.colDef?.avatar ?? props.colDef?.context?.avatar;
  const textVariant = props.colDef?.textVariant ?? props.colDef?.context?.textVariant ?? "tableList";
  
  //call any value formatters if they exist
  let value = props.colDef.valueFormatter
    ? props.colDef.valueFormatter(props)
    : props.value;

  return (
    <SFStack
      direction="row"
      alignItems={alignItems}
      sx={{ height: "100%" }}
    >
      {avatar && props.value && (
        <AvatarStyled
          bgColor={
            avatarColors[Math.floor(Math.random() * avatarColors.length)]
          }
          component={"span"}
        >
          {getInitials(value)}
        </AvatarStyled>
      )}
      {props.icon && props.icon}
      {customElement &&
        React.cloneElement(customElement, {
          props: customElement.props,
          children: value,
        })}
      {!customElement && (
        <SFTypography
          variant={textVariant}
          textEllipsis
        >
          {value}
        </SFTypography>
      )}
    </SFStack>
  );
};

function getInitials(input) {
  let initials = input.split(" ");
  return initials[0][0] + initials[initials.length - 1][0];
}

SFCellTextRenderer.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any,
  textComponent: PropTypes.element,
  avatar: PropTypes.bool,
};

export default SFCellTextRenderer;
